/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Device_General_HeadlineInputs */

const de_device_general_headline = /** @type {(inputs: Device_General_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbundene Geräte verwalten`)
};

/** @type {(inputs: Device_General_HeadlineInputs) => LocalizedString} */
const en_device_general_headline = de_device_general_headline;

/**

* @param {Device_General_HeadlineInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const device_general_headline = /** @type {((inputs?: Device_General_HeadlineInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Device_General_HeadlineInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_device_general_headline(inputs)
	return en_device_general_headline(inputs)
});